module.exports = __webpack_public_path__ + "static/typography-weights-05842ce5910f0829f6bdc7cfd3bb3b22.svg";